import {
  State,
  Action,
  StateContext,
  Selector,
  Store,
  Select,
} from "@ngxs/store";
import { patch } from "@ngxs/store/operators";
import { Injectable } from "@angular/core";
import * as AldActions from "./ald.action";
import { AldService } from "./ald.service";
import { BannerService } from "../../shared/services/banner.service";
import { HelperService } from "../../../../src/app/services/helper/helper.service";
import { GarageSearchModel } from "../../models/garage/garageSearch";
import { HttpEventType } from "@angular/common/http";
import * as Models from "../../models/commonModels";
import * as GarageModels from "../../models/garage/garage";
import * as CarModels from "../../models/car/car";
import * as GarageVisitsModels from '../../models/garage-visits/garage-visits';
import * as DepositeModels from '../../models/deposite/deposite';
import * as TyreOrderModels from '../../models/tyre-order/tyre-order';
import * as RelocationOrderModels from '../../models/relocation-order/relocation-order';
import * as AldModels from '../../models/ald/ald';

export interface AldStateModel {

  Car: Models.Response<CarModels.CarModel>;
  MainVisits: Models.ResponseList<GarageVisitsModels.GarageVisitModel>;
  Deposites: Models.ResponseList<DepositeModels.DepositeModel>;
  TyreOrders: Models.ResponseList<TyreOrderModels.TyreOrderModel>;
  RelocationOrders: Models.ResponseList<RelocationOrderModels.RelocationOrderModel>;
  Deposite: Models.Response<DepositeModels.DepositeModel>;
  GarageVisit: Models.Response<GarageVisitsModels.GarageVisitModel>;
  Summary: Models.Response<AldModels.AldSummaryModel>;
  TyreOrder: Models.Response<TyreOrderModels.TyreOrderModel>;
  RelocationOrder: Models.Response<RelocationOrderModels.RelocationOrderModel>;
  RelocationGarages: Models.ResponseList<GarageModels.GaragePreviewModel>;
  GarageVisitRequest: Models.Response<GarageVisitsModels.GarageVisitRequestModel>;
  DefaultGarage: Models.Response<GarageModels.GaragePreviewModel>;
  AvailableDefaultGarages: Models.ResponseList<GarageModels.GaragePreviewModel>;
  SendMessage: Models.ResponseBase;
}

@State<AldStateModel>({
  name: "aldState",
  defaults: {
    Car: null,
    MainVisits: null,
    Deposites: null,
    TyreOrders: null,
    RelocationOrders: null,
    Deposite: null,
    GarageVisit: null,
    Summary: null,
    TyreOrder: null,
    RelocationOrder: null,
    RelocationGarages: null,
    GarageVisitRequest: null,
    DefaultGarage: null,
    AvailableDefaultGarages: null,
    SendMessage : null
  },
})
@Injectable()
export class AldState {

  constructor(
    private helperService: HelperService,
    private aldService: AldService,
    private bannerService: BannerService
  ) { }

  @Selector()
  static Car(state: AldStateModel) {
    return state.Car;
  }

  @Selector()
  static MainVisits(state: AldStateModel) {
    return state.MainVisits;
  }

  @Selector()
  static Deposites(state: AldStateModel) {
    return state.Deposites;
  }

  @Selector()
  static TyreOrders(state: AldStateModel) {
    return state.TyreOrders;
  }

  @Selector()
  static RelocationOrders(state: AldStateModel) {
    return state.RelocationOrders;
  }

  @Selector()
  static Deposite(state: AldStateModel) {
    return state.Deposite;
  }

  @Selector()
  static Summary(state: AldStateModel) {
    return state.Summary;
  }

  @Selector()
  static TyreOrder(state: AldStateModel) {
    return state.TyreOrder;
  }

  @Selector()
  static RelocationOrder(state: AldStateModel) {
    return state.RelocationOrder;
  }

  @Selector()
  static GarageVisit(state: AldStateModel) {
    return state.GarageVisit;
  }

  @Selector()
  static RelocationGarages(state: AldStateModel) {
    return state.RelocationGarages;
  }

  @Selector()
  static GarageVisitRequest(state: AldStateModel) {
    return state.GarageVisitRequest;
  }

  @Selector()
  static AvailableDefaultGarages(state: AldStateModel) {
    return state.AvailableDefaultGarages;
  }

  @Selector()
  static DefaultGarage(state: AldStateModel) {
    return state.DefaultGarage;
  }

  @Selector()
  static SendMessage(state: AldStateModel) {
    return state.SendMessage;
  }


  @Action(AldActions.CarGet)
  CarGet(
    context: StateContext<AldStateModel>,
    action: AldActions.CarGet
  ) {
    const errorMessage = "Błąd pobierania informacji o samochodzie.";

    context.setState(
      patch({
        Car: null,
      })
    );

    this.aldService.carGet(action.Car).subscribe(
      (ret) => {
        if (ret.Success) {
          context.setState(
            patch({
              Car: ret,
            })
          );
        } else {
          this.bannerService.error(errorMessage);
        }
      },
      (error) => {
        this.helperService.SaveException(
          "AldActions.CarGet",
          error
        );

        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(AldActions.CarSet)
  CarSet(context: StateContext<AldStateModel>,
    action: AldActions.CarSet) {
    const errorMessage = "Błąd zapisu danych użytkownika.";

    this.aldService.carSet(action.Car).subscribe(
      (ret) => {
        this.bannerService.success("Dane użytkownika zapisane.");

        context.setState(
          patch({
            Car: ret,
          })
        );
      },

      (error) => {
        context.setState(
          patch({
            Car: null,
          })
        );

        this.helperService.SaveException("AldActions.CarSet", error);

        this.bannerService.error(errorMessage);
      },
      () => { }
    );
  }

  @Action(AldActions.VisitsGet)
  VisitsGet(
    context: StateContext<AldStateModel>,
    action: AldActions.VisitsGet
  ) {
    const errorMessage = "Błąd pobierania informacji o umówieniach.";

    context.setState(
      patch({
        MainVisits: null,
      })
    );

    this.aldService.getMainVisits(action.Car).subscribe(
      (ret) => {
        if (ret.Success) {
          context.setState(
            patch({
              MainVisits: ret,
            })
          );
        } else {
          this.bannerService.error(errorMessage);
        }
      },
      (error) => {
        this.helperService.SaveException(
          "AldActions.VisitsGet",
          error
        );

        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(AldActions.DepositesGet)
  DepositesGet(
    context: StateContext<AldStateModel>,
    action: AldActions.DepositesGet
  ) {
    const errorMessage = "Błąd pobierania informacji o depozytach.";

    context.setState(
      patch({
        Deposites: null,
      })
    );

    this.aldService.getDeposites(action.Car).subscribe(
      (ret) => {
        if (ret.Success) {
          context.setState(
            patch({
              Deposites: ret,
            })
          );
        } else {
          this.bannerService.error(errorMessage);
        }
      },
      (error) => {
        this.helperService.SaveException(
          "AldActions.DepositesGet",
          error
        );

        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(AldActions.TyreOrdersGet)
  TyreOrdersGet(
    context: StateContext<AldStateModel>,
    action: AldActions.TyreOrdersGet
  ) {
    const errorMessage = "Błąd pobierania informacji o zleceniach zamówień opon.";

    context.setState(
      patch({
        TyreOrders: null,
      })
    );

    this.aldService.getTyreOrders(action.Car).subscribe(
      (ret) => {
        if (ret.Success) {
          context.setState(
            patch({
              TyreOrders: ret,
            })
          );
        } else {
          this.bannerService.error(ret.Message);
        }
      },
      (error) => {
        this.helperService.SaveException(
          "AldActions.TyreOrdersGet",
          error
        );

        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(AldActions.RelocationOrdersGet)
  RelocatoinOrdersGet(
    context: StateContext<AldStateModel>,
    action: AldActions.RelocationOrdersGet
  ) {
    const errorMessage = "Błąd pobierania informacji o zleceniach relokacji opon.";

    context.setState(
      patch({
        RelocationOrders: null,
      })
    );

    this.aldService.getRelocationOrders(action.Car).subscribe(
      (ret) => {



        if (ret.Success) {

          context.setState(
            patch({
              RelocationOrders: ret,
            })
          );
        } else {
          this.bannerService.error(errorMessage);
        }
      },
      (error) => {
        this.helperService.SaveException(
          "AldActions.RelocatoinOrdersGet",
          error
        );

        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(AldActions.DepositeGet)
  DepositeGet(
    context: StateContext<AldStateModel>,
    action: AldActions.DepositeGet
  ) {
    const errorMessage = "Błąd pobierania informacji o depozycie.";

    context.setState(
      patch({
        Deposites: null,
      })
    );

    this.aldService.getDeposite(action.Deposite).subscribe(
      (ret) => {
        if (ret.Success) {
          context.setState(
            patch({
              Deposite: ret,
            })
          );
        } else {
          this.bannerService.error(errorMessage);
        }
      },
      (error) => {
        this.helperService.SaveException(
          "AldActions.DepositeGet",
          error
        );

        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(AldActions.GarageVisitCreate)
  GarageVisitCreate(
    context: StateContext<AldStateModel>,
    action: AldActions.GarageVisitCreate
  ) {
    const errorMessage = 'Błąd rezerwacji nowej wizyty.';

    this.aldService.createGarageVisit(action.GarageVisit).subscribe(
      ret => {

        if (ret.Success) {

          this.bannerService.success('Zarezerwowano nową wizytę.');

          if (ret.Message && ret.Message.length > 0) {
            this.bannerService.info(ret.Message);
          }
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }

        context.setState(
          patch({
            GarageVisit: ret
          })
        );
      },

      (error) => {

        this.helperService.SaveException('GarageVisitsActions.GarageVisitCreate', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(AldActions.SummaryGet)
  SummaryGet(
    context: StateContext<AldStateModel>,
    action: AldActions.CarGet
  ) {
    const errorMessage = "Błąd pobierania podsumowania panelu umówień.";

    context.setState(
      patch({
        Summary: null,
      })
    );

    this.aldService.summaryGet(action.Car).subscribe(
      (ret) => {
        if (ret.Success) {
          context.setState(
            patch({
              Summary: ret,
            })
          );
        } else {
          this.bannerService.error(errorMessage);
        }
      },
      (error) => {
        this.helperService.SaveException(
          "AldActions.SummaryGet",
          error
        );

        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(AldActions.TyreOrderGet)
  TyreOrderGet(
    context: StateContext<AldStateModel>,
    action: AldActions.TyreOrderGet
  ) {

    const errorMessage = "Błąd pobierania informacji o zamówieniu opon.";

    context.setState(
      patch({
        TyreOrder: null,
      })
    );

    this.aldService.getTyreOrder(action.TyreOrder).subscribe(
      (ret) => {
        if (ret.Success) {
          context.setState(
            patch({
              TyreOrder: ret,
            })
          );
        } else {
          this.bannerService.error(errorMessage);
        }
      },
      (error) => {
        this.helperService.SaveException(
          "AldActions.TyreOrderGet",
          error
        );

        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(AldActions.RelocationOrderGet)
  RelocatoinOrderGet(
    context: StateContext<AldStateModel>,
    action: AldActions.RelocationOrderGet
  ) {
    const errorMessage = "Błąd pobierania informacji o relokacji opon.";

    context.setState(
      patch({
        RelocationOrder: null,
      })
    );

    this.aldService.getRelocationOrder(action.RelocatoinOrder).subscribe(
      (ret) => {

        if (ret.Success) {
          context.setState(
            patch({
              RelocationOrder: ret,
            })
          );
        } else {
          this.bannerService.error(errorMessage);
        }
      },
      (error) => {
        this.helperService.SaveException(
          "AldActions.RelocatoinOrderGet",
          error
        );

        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(AldActions.RelocationOrderCreate)
  RelocatoinOrderCreate(
    context: StateContext<AldStateModel>,
    action: AldActions.RelocationOrderCreate
  ) {
    const errorMessage = "Błąd tworzenia zlecenia relokacji.";

    context.setState(
      patch({
        RelocationOrder: null,
      })
    );

    this.aldService.createRelocationOrder(action.RelocatoinOrder).subscribe(
      (ret) => {

        context.setState(
          patch({
            RelocationOrder: ret,
          })
        );

        if (!ret.Success) {
          this.bannerService.instantError(errorMessage + "<br/>" + ret.Message);
        }

      },
      (error) => {
        this.helperService.SaveException(
          "AldActions.RelocatoinOrderCreate",
          error
        );

        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(AldActions.RelocationGarageGet)
  RelocationGarageGet(
    context: StateContext<AldStateModel>,
    action: AldActions.RelocationGarageGet
  ) {
    const errorMessage = "Błąd pobierania listy dostepnych garaży do relokacji.";

    context.setState(
      patch({
        RelocationGarages: null,
      })
    );

    this.aldService.getRelocationGarages(action.Deposite).subscribe(
      (ret) => {

        if (ret.Success) {
          context.setState(
            patch({
              RelocationGarages: ret,
            })
          );
        } else {
          this.bannerService.error(ret.Message);
        }
      },
      (error) => {
        this.helperService.SaveException(
          "AldActions.RelocationGarageGet",
          error
        );

        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(AldActions.GarageVisitRequestForDeposite)
  GarageVisitRequestForDeposite(
    context: StateContext<AldStateModel>,
    action: AldActions.GarageVisitRequestForDeposite
  ) {
    const errorMessage = 'Błąd rejestracji proźby o wizytę.';

    this.aldService.createGarageVisitRequestForDeposite(action.Deposite).subscribe(
      ret => {

        if (ret.Success) {

          this.bannerService.success('Zarejestrowano zgłoszenie z proźbą o umówienie wizyty.');

          if (ret.Message && ret.Message.length > 0) {
            this.bannerService.info(ret.Message);
          }
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }

        context.setState(
          patch({
            GarageVisitRequest: ret
          })
        );
      },

      (error) => {

        this.helperService.SaveException('GarageVisitsActions.GarageVisitRequestForDeposite', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(AldActions.GarageVisitRequestForTyreOrder)
  GarageVisitRequestForTyreOrder(
    context: StateContext<AldStateModel>,
    action: AldActions.GarageVisitRequestForTyreOrder
  ) {
    const errorMessage = 'Błąd rejestracji proźby o wizytę.';

    this.aldService.createGarageVisitRequestForTyreOrder(action.TyreOrder).subscribe(
      ret => {

        if (ret.Success) {

          this.bannerService.success('Zarejestrowano zgłoszenie z proźbą o umówienie wizyty.');

          if (ret.Message && ret.Message.length > 0) {
            this.bannerService.info(ret.Message);
          }
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }

        context.setState(
          patch({
            GarageVisitRequest: ret
          })
        );
      },

      (error) => {

        this.helperService.SaveException('GarageVisitsActions.GarageVisitRequestForDeposite', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(AldActions.AvailableDefaultGarageGet)
  AvailableDefaultGarageGet(
    context: StateContext<AldStateModel>,
    action: AldActions.AvailableDefaultGarageGet
  ) {
    const errorMessage = "Błąd pobierania listy dostepnych garaży.";

    context.setState(
      patch({
        AvailableDefaultGarages: null,
      })
    );

    this.aldService.getAvailableDefaultGarages(action.Car).subscribe(
      (ret) => {

        if (ret.Success) {
          context.setState(
            patch({
              AvailableDefaultGarages: ret,
            })
          );
        } else {
          this.bannerService.error(errorMessage);
        }
      },
      (error) => {
        this.helperService.SaveException(
          "AldActions.AvailableDefaultGarageGet",
          error
        );

        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(AldActions.DefaultGarageSet)
  DefaultGarageSet(
    context: StateContext<AldStateModel>,
    action: AldActions.DefaultGarageSet
  ) {
    const errorMessage = "Błąd ustawiania zlecenia domyślnego garażu.";

    context.setState(
      patch({
        DefaultGarage: null,
      })
    );

    this.aldService.setDefaultGarage(action.Garage).subscribe(
      (ret) => {

        if (ret.Success) {
          context.setState(
            patch({
              DefaultGarage: ret,
            })
          );
        } else {
          this.bannerService.error(errorMessage);
        }
      },
      (error) => {
        this.helperService.SaveException(
          "AldActions.DefaultGarageSet",
          error
        );

        this.bannerService.error(errorMessage);
      }
    );
  }

  @Action(AldActions.SendMessage)
  SendMessage(
    context: StateContext<AldStateModel>,
    action: AldActions.SendMessage
  ) {
    const errorMessage = "Błąd wysyłania wiadomości";

    context.setState(
      patch({
        SendMessage: null,
      })
    );

    this.aldService.sendMessage(action.Message).subscribe(
      (ret) => {

        if (ret.Success) {
          context.setState(
            patch({
              SendMessage: ret,
            })
          );
        } else {
          this.bannerService.error(errorMessage);
        }
      },
      (error) => {
        this.helperService.SaveException(
          "AldActions.SendMessage",
          error
        );

        this.bannerService.error(errorMessage);
      }
    );
  }
}
